<template>
  <div>
    <headMeun :list="headMenuList" @selectedId="getLeftMenu" :sId="cateOneId"></headMeun>
    <leftMeun></leftMeun>
  </div>
</template>
<script>
import { headMeun, leftMeun } from "./component";
import { getCategory, goodsList } from '@/api/goods'

async function getCateList (grade, id) {
  console.log(grade);
  const result = await getCategory({
    grade: grade,
    parent_id: id || 0
  })
  return result
}


export default {

  components: {
    headMeun,
    leftMeun
  },
  data () {
    return {
      cateOneId: 0,
      cateTwoId: 0,
      goodsList: [],
      headMenuList: [],
      leftMenuList: []
    }
  },
  methods: {
    // 获取商品
    getGoodsList () { },
    // 获取分类

    async getHeadMenu () {
      const result = await getCateList(1, 0)
      if (result.data.data.status) {
        this.headMenuList = result.data.data.cartList
      }
    },
    getLeftMenu (pid) {
    }
  },
  created () {
    this.getHeadMenu()
  }
}
</script>